<template>
    <article
        :class="showColumn == true ? 'col-12 col-sm-6 col-lg-4 col-xl-3 mb-5' : ' h-100 w-100'"
    >
        <router-link :to="newsData.jsonUrl" class="card-index">
            <div v-if="newsData.featuredImage.url !== null" class="card-header">
                <div
                    class="img-header bg-img"
                    :style="{
                        backgroundImage: `url(${newsData.featuredImage.url})`,
                    }"
                >
                    <div class="overlay"></div>
                </div>
            </div>
            <div class="card-body">
                <div class="subject-wrapper">
                    <p class="date">{{ thePostDate(newsData.postDate.date) }}</p>
                </div>
                <div class="subject-wrapper">

                    <div v-if="newsData.titleEditorStyle">
                        <h6 class="title" v-html="removeP(newsData.titleEditorStyle)">
                        </h6>
                    </div>
                    <div v-else>
                        <h6 class="title" v-html="newsData.title"></h6>
                    </div>

                </div>

                <div class="subject-wrapper">
                    <p class="exerpt" v-html="newsData.newsExerpt"></p>
                </div>
            </div>
            <div class="card-footer">
                <p class="link-arrow left-to-right bold text-red no-margin"></p>
            </div>
        </router-link>
    </article>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import dayjs from 'dayjs'
// import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'NewsCard',
    components: {
        // AssetLoader
    },
    props: {
        newsData: {
            type: Object,
            required: true,
        },
        showColumn: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
        thePostDate(actualDate) {
            var date = new Date(actualDate)
            return dayjs(date).format('D MMMM YYYY')
        },
        removeP(str) {
            const newString = str.replace('<p>', "");
            return newString.replace('</p>', "");
        },
    },
    // On loaded...
    mounted() {},
}
</script>
